<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-navbar></layout-navbar>
    <!-- Page Wrapper -->
    <div class="page-wrapper">

      <!-- Page Content -->
      <div class="content container-fluid">
        <div class="crms-title row bg-white">
          <div class="col">
            <h3 class="page-title m-0">
			                <span class="page-title-icon bg-gradient-primary text-white mr-2">
			                  <i class="feather-database"></i>
			                </span> {{customer_name}} </h3>
          </div>
          <div class="col text-right">
            <ul class="list-inline-item pl-0">
              <li class="nav-item dropdown list-inline-item add-lists">
                <a class="nav-link dropdown-toggle" id="profileDropdown" href="#" data-toggle="dropdown" aria-expanded="false">
                  <div class="nav-profile-text">
                    <i class="fa fa-th" aria-hidden="true"></i>
                  </div>
                </a>
                <div class="dropdown-menu navbar-dropdown" aria-labelledby="profileDropdown">

                  <router-link class="dropdown-item" to="/gap-list">Liste Ansicht</router-link>
                  <router-link class="dropdown-item" to="/gap-survey">Fragebogen Ansicht</router-link>
                </div>
              </li>
              <li class="list-inline-item">
                <button class="add btn btn-gradient-primary font-weight-bold text-white todo-list-add-btn btn-rounded" id="add_gap_question" data-toggle="modal" data-target="#add_gap_question_modal">GAP Analyse</button>
              </li>
            </ul>
          </div>
        </div>
        <div id="surveyContainer">
          <h2>Gap Analyse</h2>
          <survey :survey="survey"></survey>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as SurveyVue from 'survey-vue';
import "survey-vue/defaultV2.css";
import service from '@/utils/request.js'
// import $ from 'jquery'

import * as widgets from "surveyjs-widgets";

import { init as customWidget } from "@/components/survey/customwidget";

SurveyVue.StylesManager.applyTheme("defaultV2");
const Survey = SurveyVue.Survey;

// widgets.icheck(SurveyVue);
widgets.select2(SurveyVue);
widgets.inputmask(SurveyVue);
widgets.jquerybarrating(SurveyVue);
widgets.jqueryuidatepicker(SurveyVue);
widgets.nouislider(SurveyVue);
widgets.select2tagbox(SurveyVue);
widgets.sortablejs(SurveyVue);
widgets.ckeditor(SurveyVue);
widgets.autocomplete(SurveyVue);
widgets.bootstrapslider(SurveyVue);
customWidget(SurveyVue);

export default {
  name: 'TestGap',
  components: {
    Survey
  },
  data: function() {
    const model = new SurveyVue.Model(this.surveyJSON)
    return {
      survey: model,
      surveyJSON: '',
      options: [],
      selected_value: '',
      survey_id: 1,
      dialogVisible: false,
      help_text: 'Help',
      original_answers: []
    }
  },
  created() {
    this.showSurvey()
  },
  mounted() {
  },
  methods: {
    submitAnswer: function(survey_result) {
      let return_data = []
      let data = []
      let current_answer = {}
      let question_id = ''
      let question_answer = {}
      let active = true
      const that = this
      for (const [key, value] of Object.entries(survey_result.data)) {
        if (key.substring(key.length - 9) === '-Document' || key.substring(key.length - 8) === '-Comment') {
          question_id = key.substring(8, key.indexOf('-'))
          let current_element = return_data.find(function(element) {
            return element.question === question_id
          })
          if (key.substring(key.length - 9) === '-Document') {
            current_element.question_answer.document = { 'name': value.name, 'path': value.path, 'version': value.version }
          } else current_element.question_answer.comment = value
        } else {
          question_id = key.substring(8)
          question_answer = { 'answer': value, 'comment': '', 'document': {}}
          active = true
          current_answer = { 'question': question_id, 'question_answer': question_answer, 'active': active,
            'modified_by': that.$store.getters.id }
          return_data.push(current_answer)
        }
      }
      if (that.original_answers.length > 0) {
        return_data.forEach(function(item, index) {
          let original_answer = that.original_answers.find(element => {
            return String(element.question) === String(item.question)
          })
          if (original_answer !== undefined) {
            if (JSON.stringify(original_answer.question_answer) !== JSON.stringify(item.question_answer)) {
              data.push(item)
            }
          } else {
            data.push(item)
          }
        })
      }
      service.request({
        url: 'todos/v1/answers/',
        method: 'POST',
        data: { 'answers': data },
        contentType: 'application/json; charset=utf-8'
      }).then(function(response) {
        console.log('ready')
      }).catch(function(err) {
        console.log(err)
      })
    },
    getSurveys: async function() {
      const that = this
      service.request({
        url: 'todos/v1/customer_questionaire/',
        method: 'GET',
        responseType: 'json'
      }).then(function(response) {
        let select_data = []
        const return_data = response.data.results
        return_data.forEach(function(item, index) {
          let current_customer = { 'value': item.name, 'label': item.name, 'children': [] }
          const surveys = item['questionaires']
          surveys.forEach(function(item, index) {
            current_customer.children.push({ 'value': item.id, 'label': item.name })
          })
          select_data.push(current_customer)
        })
        that.options = select_data.slice(0)
      }).catch(function(err) {
        console.log(err)
      })
    },
    showSurvey: async function() {
      const that = this
      service.request({
        url: 'todos/v1/questionaire/' + that.survey_id + '/',
        method: 'GET',
        responseType: 'json'
      }).then(function(response) {
        // console.log(response.content)
        that.surveyJSON = JSON.stringify(response.data.content)
        console.log(response.data.answers)
        that.original_answers = response.data.answers
        let answers = {}
        let answers_remark = {}
        that.original_answers.forEach(function(item, index) {
          answers_remark['question' + item.question] = 'Eingetragen am ' + item.modified_on +
            ' von ' + item.modified_by
          answers['question' + item.question] = item.question_answer.answer
          if (item.question_answer.comment !== '') {
            answers['question' + item.question + '-Comment'] = item.question_answer.comment
          }
          if (item.question_answer.document !== {}) {
            answers['question' + item.question + '-Document'] = item.question_answer.document
          }
        })
        that.survey_pages = JSON.parse(that.surveyJSON)['pages']
        SurveyVue.JsonObject.metaData.addProperty('question', 'help_text:text')
        SurveyVue.JsonObject.metaData.addProperty('page', 'help_text:text')
        SurveyVue.JsonObject.metaData.addClass('ddk_radiogroup', [{ name: 'hasComment', visible: false },
          { name: 'hasOther', visible: false }, { name: 'choices', visible: false }], null, 'radiogroup')
        function isCommentRequired(value) {
          return value === 'teilweise' || value === 'nicht_zutreffend'
        }

        function isDDKRadioQuestion(question) {
          return !!question && question.getType() === 'ddk_radiogroup'
        }

        function onDDK_RadioValueChanged(sender, options) {
          if (!isDDKRadioQuestion(options.question)) return
          let commentText = 'Bemerkung'
          if (isCommentRequired(options.value)) {
            commentText += ' **'
          }
          commentText += ':'
          options.question.commentText = commentText
        }

        function onDDK_RadioValidateQuestion(sender, options) {
          if (!isDDKRadioQuestion(options.question)) return
          if (isCommentRequired(options.value) && !options.question.comment) {
            options.error = 'Bitte Bemerkungen eintragen'
          }
        }
        function showDescription(element) {
          that.help_text = element
          that.dialogVisible = true
        }
        const model = new SurveyVue.Model(that.surveyJSON)
        model.onValueChanged.add(
          onDDK_RadioValueChanged
        )
        model.onValidateQuestion.add(
          onDDK_RadioValidateQuestion
        )
        model.onAfterRenderQuestion.add(function(survey, options) {
          // Return if there is no description to show in popup
          // console.log(options.question.help_text)
          if (!options.question.help_text) return
          // Add a button;
          const btn = document.createElement('button')
          btn.type = 'button'
          btn.className = 'btn btn-info btn-xs'
          btn.innerHTML = 'More Info'
          const question = options.question
          btn.onclick = function() { showDescription(question.help_text) }
          const header = options.htmlElement.querySelector('h5')
          const span = document.createElement('span')
          const span_text = document.createElement('span')
          span.innerHTML = '  '
          span_text.innerHTML = '<b style="color: red">' + answers_remark[question.name] + '</b>'
          header.appendChild(span)
          header.appendChild(btn)
          if (answers_remark[question.name] !== undefined) {
            header.appendChild(span)
            header.appendChild(span_text)
          }
        })
        model.onAfterRenderPage.add(function(survey, options) {
          // Return if there is no description to show in popup
          if (!options.page.help_text) return
          // Add a button;
          const btn = document.createElement('button')
          btn.type = 'button'
          btn.className = 'btn btn-info btn-xs'
          btn.innerHTML = 'More Info'
          const page = options.page
          btn.onclick = function() { showDescription(page.help_text) }
          const header = options.htmlElement.querySelector('h4')
          const span = document.createElement('span')
          span.innerHTML = '  '
          header.appendChild(span)
          header.appendChild(btn)
        })
        model.onComplete.add(that.submitAnswer)
        model.data = answers
        that.survey = model
      }).catch(function(err) {
        console.log(err)
      })
    }
  }
}
</script>

<style>

</style>
